import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type ChecklistProps = {
    className?: string;
};

const Checklist: FunctionComponent<ChecklistProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'checklist'}
            viewBox="0 0 188.1 250"
        >
            <path d="M187.4 38.2c0-10.8-8.8-19.4-19.5-19.3l-23.8.1c-1.9-5.7-4.7-10.2-8.3-13.5-6.3-5.6-12.9-5.6-14.5-5.5L67.4.1c-7.5 0-13.7 2.6-18.3 7.7-3.1 3.3-5.1 7.3-6.6 11.4l-23.1.1C8.6 19.3-.1 28 0 38.8l.6 191.8c0 10.8 8.8 19.4 19.5 19.3l148.6-.4c10.8 0 19.4-8.8 19.3-19.5l-.6-191.8zM55.5 13.9c3-3.2 6.9-4.8 11.8-4.8l54.1-.2h.5s4-.3 7.9 3.2c3.4 3.1 7.4 9.6 8.2 23.7l-89.4.3c.2-6.5 1.7-16.4 6.9-22.2zm113.1 226.6l-148.6.4c-5.8 0-10.5-4.7-10.5-10.5L9 38.7c0-5.8 4.7-10.5 10.5-10.5l20.9-.1c-1 6.8-.7 12.3-.7 12.8.2 2.4 2.1 4.2 4.5 4.2l98.5-.3c2.5 0 4.5-2 4.5-4.5 0-4.5-.3-8.7-.9-12.5l21.7-.1c5.8 0 10.5 4.7 10.5 10.5l.6 191.8c-.1 5.8-4.7 10.5-10.5 10.5z" />
            <path d="M156 102l-58.1 50.5-20.6-27.8c-1.5-2-4.3-2.4-6.3-.9s-2.4 4.3-.9 6.3l23.5 31.7c.7 1 1.9 1.7 3.1 1.8h.5c1.1 0 2.1-.4 2.9-1.1l61.8-53.6c1.9-1.6 2.1-4.5.5-6.3-1.7-2-4.5-2.2-6.4-.6z" />
            <path d="M141.7 136.1c.1 1.4.2 2.7.2 4.1.1 26.6-21.5 48.4-48.2 48.4S45.4 167 45.4 140.4C45.3 113.8 66.9 92 93.6 92c16.7-.1 30.3 7 39.1 19.7l6.7-6C129 91 113 83 93.6 83c-31.6.1-57.1 25.8-57 57.4.1 31.6 25.8 57.1 57.4 57s57.1-25.8 57-57.4c0-3.6-.4-7.1-1-10.5l-8.3 6.6z" />
        </svg>
    );
};
export default Checklist;
